import { Component, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"]
})
export class HeaderComponent implements OnInit {
  locale = false;
  localeList = [
    {
      name: "dutch",
      code: "du"
    },
  ];

  constructor(public translate: TranslateService) {}

  ngOnInit() {
    const localeCookie = this.getCookie("ls3-language");
    if (localeCookie !== "") {
      this.translate.use(localeCookie);
    }
  }

  openLocale() {
    this.locale = !this.locale;
  }

  reload() {
    window.location.reload();
  }

  changeLocale(locale) {
    this.setCookie("ls3-language", locale, 7);
    this.translate.use(locale);
    this.locale = false;
  }

  private setCookie(
    name: string,
    value: string,
    expireDays: number,
    path: string = ""
  ) {
    const d = new Date();
    d.setTime(d.getTime() + expireDays * 24 * 60 * 60 * 1000);
    const expires = `expires=${d.toUTCString()}`;
    const cpath = path ? `; path=${path}` : "";
    document.cookie = `${name}=${value}; ${expires}${cpath}`;
  }

  private getCookie(name: string) {
    const ca: Array<string> = document.cookie.split(";");
    const caLen: number = ca.length;
    const cookieName = `${name}=`;
    let c: string;

    for (let i = 0; i < caLen; i += 1) {
      c = ca[i].replace(/^\s+/g, "");
      if (c.indexOf(cookieName) === 0) {
        return c.substring(cookieName.length, c.length);
      }
    }
    return "";
  }
}



// WEBPACK FOOTER //
// ./src/app/header/header.component.ts